import clsx from "clsx";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";

import { AddDeviceFormType } from "@/apps/partner/types";
import { Accordion } from "@/components/Interface/Accordion/Accordion";
import { RadioButton } from "@/components/Interface/FormFields/RadioButton/RadioButton";

export const NumberPortingChoice = ({
  setNumberPortingChoice,
  optionSelected,
}: {
  setNumberPortingChoice: (choice: boolean) => void;
  optionSelected: boolean;
}) => {
  const { t } = useTranslation();

  const {
    formState: { errors },
    register,
    watch,
    unregister,
  } = useFormContext<AddDeviceFormType>();

  const selectedNumberPorting = watch("onp");

  useEffect(() => {
    setNumberPortingChoice(selectedNumberPorting === "true");
    if (selectedNumberPorting === "false") {
      unregister("mnpData");
    }
  }, [selectedNumberPorting, setNumberPortingChoice, unregister]);

  return (
    <fieldset
      id="numberporting-opacity-controller"
      disabled={!optionSelected}
      className={clsx(!optionSelected && "opacity-50")}
    >
      <Accordion
        label={t("Onboarding.sections.rate-selection.numberPorting")}
        canOpen={false}
        className="mt-8"
      >
        <div className="number-porting-container">
          <legend className="intro-text">
            {t("partnerPortal:addDevice.step3.takeYourNumber")}
            <p className="hint">
              <b>{t("Onboarding.sections.rate-selection.hint")}</b>
              <Trans
                components={[<b key="key" />]}
                i18nKey="Onboarding.sections.rate-selection.numberPortingHint"
              />
            </p>
          </legend>
          {/* layout for radio buttons and labels */}
          <div className="number-porting-choices">
            <div className="radio-buttons">
              <RadioButton<AddDeviceFormType>
                name="onp"
                value="true"
                labelComponent={
                  <Trans i18nKey="Onboarding.sections.rate-selection.yesTakeNumber" />
                }
                errors={errors}
                register={register}
              />
            </div>
            <div className="radio-buttons">
              <RadioButton<AddDeviceFormType>
                name="onp"
                value="false"
                labelComponent={
                  <Trans i18nKey="Onboarding.sections.rate-selection.dontTakeNumber" />
                }
                errors={errors}
                register={register}
              />
            </div>
          </div>
        </div>
      </Accordion>
    </fieldset>
  );
};
